/**
 * @file contains helper functions for the custom offset component
 */
import { TimeUnit } from '../../../../generated/graphql';
import translate from '../../../../i18n/translate';
import { MuiSelectItem } from '../../MuiSelect';

/**
 * Get the items for the select component for custom offset units
 *
 * @returns Array of items for the select component
 */
export const getCustomOffsetUnitOptions = (): MuiSelectItem[] => [
  {
    label: translate('TIME__MINUTE__PLURAL'),
    value: TimeUnit.MINUTES,
  },
  {
    label: translate('TIME__HOUR__PLURAL'),
    value: TimeUnit.HOURS,
  },
  {
    label: translate('TIME__DAY__PLURAL'),
    value: TimeUnit.DAYS,
  },
];
